import React from "react";

import index, { NUM } from "../../exp/index.js";
import { formatDate } from "../../utils/utils";

const ultimoDate = index[`exp_${NUM}`].date;

const colors = {
  bg: "#493745",
  text: "var(--background-color)",
  textOpacity: 0.4,
};

export default () => {
  return (
    <div
      className="logo"
      style={{
        background: colors.bg,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        padding: "1.5em",
        willChange: "transform",
      }}
    >
      <div
        style={{
          width: "100%",
        }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44.8 19.2">
          <g fill={colors.text}>
            <path d="M2.9 7.9C2.1 7.9 1.4 7.6.8 7 .5 6.7.3 6.3.2 5.9.1 5.5.1 4.8.1 4c0-.8 0-1.5.1-1.9.1-.4.3-.8.6-1.2C1.4.3 2.1 0 2.9 0c1.5 0 2.6.9 2.8 2.4H4.2C4.1 1.8 3.7 1.4 2.9 1.4c-.4 0-.7.1-1 .4C1.7 2.1 1.6 2.5 1.6 4S1.7 5.8 2 6.1c.2.3.6.4 1 .4.7 0 1.1-.4 1.3-1.1h1.5C5.5 7 4.4 7.9 2.9 7.9zM11.3 7.8l-.5-1.4H8.1L7.7 7.8H6.1l2.8-7.7h1.2l2.8 7.7H11.3zM9.5 2.4l-1 2.8h1.9L9.5 2.4zM13.9 7.8V.1h1.5v6.4h3.5v1.3H13.9zM22.1 7.8H21l-2.5-7.7H20l1.5 5 1.5-5h1.6L22.1 7.8zM25.6 7.8V.1h1.5v7.7H25.6zM31.5 7.9c-.8 0-1.5-.3-2.1-.8-.3-.3-.5-.7-.6-1.2-.1-.4-.1-1.1-.1-1.9 0-.8 0-1.5.1-1.9.1-.4.3-.8.6-1.2C30 .3 30.7 0 31.5 0c1.5 0 2.6.9 2.8 2.4h-1.5c-.2-.7-.6-1.1-1.3-1.1-.4 0-.7.1-1 .4-.3.3-.4.7-.4 2.2s.1 1.8.4 2.2c.2.3.6.4 1 .4.7 0 1.1-.4 1.3-1.1h1.5C34.1 7 33 7.9 31.5 7.9zM39.8 7.8V4.6h-2.6v3.2h-1.5V.1h1.5v3.2h2.6V.1h1.5v7.7H39.8zM43.1 7.8V.1h1.5v7.7H43.1z" />
          </g>
          <g fill={colors.text} opacity={colors.textOpacity}>
            <path d="M3.5 19.2c-1 0-1.8-.3-2.5-1-.4-.4-.6-.9-.7-1.4-.1-.5-.2-1.3-.2-2.3 0-1 .1-1.8.2-2.3.1-.5.3-1 .7-1.4.7-.7 1.5-1 2.5-1 1.8 0 3.1 1 3.4 2.9H5c-.2-.8-.7-1.3-1.5-1.3-.5 0-.9.2-1.1.5-.4.4-.5.8-.5 2.6s.1 2.2.5 2.6c.3.3.7.5 1.1.5.9 0 1.4-.5 1.5-1.3h1.8C6.6 18.2 5.2 19.2 3.5 19.2zM13.6 18.2c-.6.6-1.4 1-2.5 1-1 0-1.8-.4-2.5-1-.9-.9-.9-2.1-.9-3.7s0-2.7.9-3.7c.6-.6 1.4-1 2.5-1 1 0 1.8.4 2.5 1 .9.9.9 2.1.9 3.7S14.5 17.3 13.6 18.2zM12.2 11.9c-.3-.3-.7-.5-1.1-.5-.5 0-.9.2-1.2.5-.3.4-.4.8-.4 2.6 0 1.8.1 2.2.4 2.6.3.3.7.5 1.2.5.5 0 .9-.2 1.1-.5.3-.4.5-.8.5-2.6C12.7 12.8 12.6 12.3 12.2 11.9zM22.8 19.1v-5.4l-1.8 3.5h-1.2l-1.8-3.5v5.4h-1.8V9.9h1.8l2.4 5 2.4-5h1.8v9.2H22.8zM26.8 19.1V9.9h1.8v9.2H26.8zM33.8 19.2c-1 0-1.8-.3-2.5-1-.4-.4-.6-.9-.7-1.4-.1-.5-.2-1.3-.2-2.3 0-1 .1-1.8.2-2.3.1-.5.3-1 .7-1.4.7-.7 1.5-1 2.5-1 1.8 0 3.1 1 3.4 2.9h-1.8c-.2-.8-.7-1.3-1.5-1.3-.5 0-.9.2-1.1.5-.4.4-.5.8-.5 2.6s.1 2.2.5 2.6c.3.3.7.5 1.1.5.9 0 1.4-.5 1.5-1.3h1.8C36.9 18.2 35.5 19.2 33.8 19.2zM41.2 19.2c-1.4 0-2.5-.3-3.4-1.2l1.2-1.2c.6.6 1.4.8 2.2.8 1.1 0 1.6-.4 1.6-1.1 0-.3-.1-.6-.3-.8-.2-.2-.4-.3-.8-.3l-1.1-.2c-.8-.1-1.4-.4-1.8-.8-.4-.4-.7-1-.7-1.8 0-1.6 1.2-2.8 3.2-2.8 1.3 0 2.2.3 3 1.1l-1.1 1.1c-.6-.6-1.3-.6-1.9-.6-1 0-1.4.5-1.4 1.2 0 .2.1.5.3.7.2.2.5.3.9.4l1.1.2c.8.1 1.4.3 1.8.7.5.5.7 1.1.7 1.9C44.6 18.2 43.2 19.2 41.2 19.2z" />
          </g>
        </svg>
      </div>
      <div className="fecha">
        <p style={{ color: colors.text, fontSize: "2em", fontWeight: 700, margin: "0 0 0.1em 0", padding: "0" }}>
          # {NUM}
        </p>
        <p style={{ color: colors.text, fontSize: "0.8em", fontWeight: 400, margin: "0", padding: "0", opacity: colors.textOpacity, }}>
          {formatDate(ultimoDate)}
        </p>
      </div>
    </div>
  );
};
